

export default function TesimonialIcon({ className }) {
    return (
        <svg width="16" height="16" className={className} viewBox="0 0 16 16" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M14.4 0H1.6C0.72 0 0 0.72 0 1.6V16L3.2 12.8H14.4C15.28 12.8 16 12.08 16 11.2V1.6C16 0.72 15.28 0 14.4 0ZM14.4 11.2H2.56L1.6 12.16V1.6H14.4V11.2ZM8 8.32L10.08 9.6L9.52 7.2L11.36 5.6L8.96 5.36L8 3.2L7.04 5.44L4.64 5.6L6.48 7.2L5.92 9.6L8 8.32Z" fill={className} />
        </svg>
    )
}
